export const isPrimitiveType = (type: string) => {
  return ['string', 'number', 'boolean'].includes(type);
};
